import React from 'react';
import { Label } from 'components';
import StepNavigation, {
  Props as StepNavigationProps,
} from 'components/molecules/StepNavigation';
import { BaseTemplate } from 'pages';
import * as S from './style';

interface Props {
  children: React.ReactNode;
  title?: string;
  isBackBtn?: boolean;
  step?: StepNavigationProps;
}

function TemplateWithTitle({
  children,
  title,
  isBackBtn,
  step,
}: Props): React.ReactElement {
  return (
    <BaseTemplate isBackBtn={isBackBtn}>
      <S.ContentsContainer>
        {title ? (
          <S.TitleWrapper>
            <Label
              contents={title}
              color={'gray_opacity_800'}
              fontStyle={'h4_bold'}
              wordBreak={true}
            />
            {step ? <StepNavigation {...step} /> : null}
          </S.TitleWrapper>
        ) : null}
        {children}
      </S.ContentsContainer>
    </BaseTemplate>
  );
}

export default TemplateWithTitle;
